export const IMPRESSIONS = 'Impressions';

export const UPDATE_EULA = 'UpdateEula';
